import { Tile } from '@mc/design-system'
import Image from 'components/LegacyImage'
import styles from './ProductExplainer.module.scss'

interface RightImageTileProps {
  title: string
  description: string
  imageUrl: string
}

const RightImageTile = ({
  title,
  description,
  imageUrl,
}: RightImageTileProps) => (
  <Tile className={`mc-corners--md mc-bg-neutral-900 ${styles.section}`}>
    <div className='mc-p-6 d-flex flex-column justify-content-between mc-w-100 mc-h-100'>
      <div className={`mc-mb-4 ${styles.sectionCopy}`}>
        <h3 className='mc-text-h4'>{title}</h3>
        <p className='mc-mt-2'>{description}</p>
      </div>
      <div className={`flex-grow-1 ${styles.coverImageContainer}`}>
        <Image
          src={imageUrl}
          alt=''
          layout='fill'
          objectFit='contain'
          objectPosition='right'
        />
      </div>
    </div>
  </Tile>
)

export default RightImageTile
